<template>
  <div class="text-edit-page grey lighten-3 pt-0 mt-5">
    <v-layout  row wrap style="background-color:white; height:30px; width:100%; top:135px; position:fixed; z-index: 1; height:50px;">
      <v-flex xs12>
      </v-flex>
    </v-layout>

    <v-toolbar
      color="white"
      tabs
      class="text-edit-toolbar elevation-1 mt-2"
      style="top:155px; position:fixed; z-index: 1;"
    >
      <!-- style="top:136px; position:fixed; z-index: 1;" -->
      <!-- <v-btn icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-btn> -->
      <v-toolbar-title class="pl-3 headline" v-html="text.given_filename">
        <!-- {{text.title}} -->
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="c_user.delete_rights" small icon class="mr-3" @click="deleteText()" right>
        <v-icon small color="red">delete</v-icon>
      </v-btn>
      <v-btn small icon class="mr-3" @click="$router.go(-1)" right>
        <v-icon small>close</v-icon>
      </v-btn>
      <v-btn icon small :disabled="!valid" @click="saveText" right> 
        <v-icon small>save</v-icon>
      </v-btn>

      <!-- <v-layout align-center justify-end ml-0>
        <v-btn small disabled color="red" outline @click="deleteText()" v-if="c_user.delete_rights" class="mr-5"
          >delete</v-btn
        >
        <v-btn outline small @click="$router.go(-1)"
          >CANCEL</v-btn
        >
        <v-btn small :disabled="text.title == null" dark @click="saveText()">SAVE</v-btn>
      </v-layout> -->
      <!-- <a
        class="headline mr-2 pr-2 black--text"
        @click="
          options = false;
          $router.go(-1);
        "
        >close</a
      > -->
    </v-toolbar>
    
    <!-- <v-toolbar tabs color="white elevation-0" style="top:67px; position:fixed; z-index: 1;">
      <v-btn icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-btn>
      <v-toolbar-title class="ml-4">{{text.title}} </v-toolbar-title>
      <v-menu bottom right>
        <v-btn slot="activator" icon>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="addToSelection(text.id)">
            <v-list-tile-title>Add this artwork to list</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>       -->
    <!-- <v-btn icon><v-icon>more_vert</v-icon></v-btn> -->
    <!-- <small v-if="artworkFormData.artist">{{artworkFormData.artist.name}}</small> -->
    <!-- <v-tabs slot="extension" color="transparent" slider-color="purple"  align-with-title v-model="currentTab" show-arrows>
        <v-tab v-for="tab in fields.tabs" :ripple="false"
          :key="tab.key"
          :href="'#tab-' + tab.key" 
          @click="saveCurrentTab('tab-' + tab.key)"
          v-if="tab.work_types && tab.work_types.includes(artworkFormData.classification)"
        >
          {{ tab.title }}
        </v-tab>
      </v-tabs> -->
    <!-- </v-toolbar> -->

    <v-form @submit.prevent ref="form" v-model="valid" lazy-validation>
      <!-- <v-card class="px-3 pt-0 mt-2 elevation-0 editBG"> -->
        <v-container grid-list-xs mx-3 pt-5 fluid class="text-edit-content">
          <v-layout row wrap mr-4 mt-4>

            <SectionHeader text="Basic" class="mb-2"></SectionHeader>

            <v-flex xs12 class="px-2">
              <v-text-field
                v-model="text.given_filename"
                label="File Name"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md6 class="px-2">
              <v-text-field
                v-model="text.title"
                label="Title Publication"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md6 class="px-2">
              <v-text-field v-model="text.editor" label="Editor"></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 class="px-2">
              <v-text-field
                v-model="text.authors"
                label="Author(s)"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 class="px-2">
              <v-text-field v-model="text.year" label="Year" mask="####"></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 class="px-2">
              <v-text-field v-model="text.place" label="Place"></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 class="px-2">
              <v-text-field
                v-model="text.publisher"
                label="Publisher"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 class="px-2">
              <v-text-field
                v-model="text.url"
                label="URL (link)"
              ></v-text-field>
            </v-flex>

            <!-- <v-flex xs12 sm6 class='px-2'>
              <v-autocomplete
                :items="this.countries"
                v-model="text.country"
                label="Country"
              ></v-autocomplete>
            </v-flex> -->

            <!-- <v-flex xs12 sm4 md2 lg2 class='pl-4 pr-3'>
              <v-text-field 
                v-model="text.duration_start_year"
                label="Start Year" placeholder="XXXX" type="number" :maxlength="4"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4 md2 lg2 pr-3>
              <v-text-field
                v-model="text.duration_start_month"
                label="Month" placeholder="XX" type="number" 
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4 md2 lg2 class='pr-4'>
              <v-text-field
                v-model="text.duration_start_day"
                label="Day" placeholder="XX" type="number" 
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm4 md2 lg2 class='px-2'>
              <v-text-field
                v-model="text.duration_end_year"
                label="End Year" placeholder="XXXX" type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4 md2 lg2 pr-3>
              <v-text-field
                v-model="text.duration_end_month"
                label="Month"
                placeholder="XX"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4 md2 lg2 pr-4>
              <v-text-field
                v-model="text.duration_end_day"
                label="Day" placeholder="XX" type="number"
              ></v-text-field>
            </v-flex> -->

            <!-- <v-flex xs12 class="pl-4 py-4"> -->
            <!-- <v-radio-group v-model="text.show_type" row>
                <v-radio label="Group Show" input-value="2" value="2" class='pr-5'></v-radio>
                <v-radio label="Solo Show" input-value="1" value="1"></v-radio>
              </v-radio-group> -->

            <v-flex xs12 md6 class="pa-2">
              <h4 class="body-2 mt-0 ml-0 mb-1 grey--text text--darken-2">Format</h4>
              <v-btn-toggle v-model="text.text_type">
                <v-btn
                  small
                  flat
                  key="print"
                  class="px-2"
                  input-value="print"
                  value="print"
                >
                  <span> Print </span>
                </v-btn>
                <v-btn
                  small
                  flat
                  key="online"
                  class="px-2"
                  input-value="online"
                  value="online"
                >
                  <span> Online </span>
                </v-btn>
              </v-btn-toggle>
            </v-flex>

            <v-flex xs12 md6 class="py-2 mb-3">
              <h4 class="body-2 mt-0 ml-0 mb-1 grey--text text--darken-2">Ownership</h4>
              <v-btn-toggle v-model="text.tba">
                <v-btn
                  small
                  flat
                  key="tba"
                  class="px-2"
                  input-value="tba"
                  value="tba"
                >
                  <span> TBA </span>
                </v-btn>
                <v-btn
                  small
                  flat
                  key="nontba"
                  class="px-2"
                  input-value="nontba"
                  value="nontba"
                >
                  <span> NON TBA </span>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
            <!-- </v-flex> -->

            <!-- <v-flex xs12 md6 lg4 py-0 mt-5 class="pl-4">
              <v-switch v-model="text.loan" label="Loan TBA21" input-value="1"></v-switch>
            </v-flex> -->
            <SectionHeader text="Type of text / resource"></SectionHeader>

            <!-- <v-flex xs12 py-0 my-0 class="pl-4">
              <h3>Type of text / resource</h3>
            </v-flex> -->

            <!-- <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
              <v-checkbox
                color="black"
                value="text.tba"
                hide-details
                label="TBA21 publication"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
              <v-checkbox
                color="black"
                value="text.nontba"
                hide-details
                label="NON TBA21 publication"
              ></v-checkbox> -->
            <!-- </v-flex> -->

            <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
              <v-checkbox
                color="black"
                v-model="text.article"
                hide-details
                label="Article (magazine, journal, etc)"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
              <v-checkbox
                color="black"
                v-model="text.artwork_text"
                hide-details
                label="Text on artwork (exhibition, website, social media etc)"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
              <v-checkbox
                color="black"
                v-model="text.pr"
                hide-details
                label="Press release"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
              <v-checkbox
                color="black"
                v-model="text.artist_documents"
                hide-details
                label="Documents received from artist, gallery, etc"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
              <v-checkbox
                color="black"
                v-model="text.transcript"
                hide-details
                label="Transcription"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 md6 lg4 py-0 mb-0 class="pl-4">
              <v-checkbox
                color="black"
                v-model="text.work_text"
                hide-details
                label="Work inherent text (part of artwork)"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 md6 lg4 py-0 mb-5 class="pl-4">
              <v-checkbox
                color="black"
                v-model="text.publication"
                hide-details
                label="Publication"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 md6 lg4 py-0 mb-5 class="pl-4">
              <v-checkbox
                color="black"
                v-model="text.donation"
                hide-details
                label="Donation"
              ></v-checkbox>
            </v-flex>

            <SectionHeader text="Assigned Artworks/Artists"></SectionHeader>

            <v-flex xs12 px-2 mt-3>
              <!-- <v-autocomplete
                v-model="text.artworks"
                :items="artworks"
                label="Artworks" item-text="title" item-value="id" multiple chips
              ></v-autocomplete> -->

              <!-- <v-combobox v-model="text.artworks" :items="artworks" label="I use a scoped slot" multiple chips :item-text="item => item.title + ', ' + item.accession_number + ', ' + item.name" item-value="id">
                <template v-slot:selection="data">
                  <v-chip
                    :key="JSON.stringify(data.item)"
                    :selected="data.selected"
                    :disabled="data.disabled"
                    class="v-chip--select-multi"
                    @input="data.parent.selectItem(data.item)"
                  >
                    <v-avatar class="accent white--text" v-text="data.item.title" ></v-avatar>
                    {{ data.item.title }}
                  </v-chip>
                </template>
              </v-combobox> -->

              <!-- <v-combobox
                v-model="text.artworks" chips clearable multiple open-on-clear
                :items="artworks"
                :item-text="item => item.title + ', ' + item.accession_number + ', ' + item.name" item-value="id"
                label="Text Artworks"
                >
                <template v-slot:selection="data">
                  <v-chip :selected="data.selected" :disabled="data.disabled" close @input="remove(data.item)" :key="JSON.stringify(data.item)" class="v-chip--select-multi">
                    <strong v-html="data.item.title"></strong>&nbsp;
                    <span>{{data.item.accession_number}} </span>&nbsp;
                    <strong v-html="data.item.name"></strong>
                  </v-chip>
                </template>
              </v-combobox> -->
              <!-- prepend-icon="filter_list" -->
              <!-- <template v-slot:item="data">
                menu-props='{"closeOnClick":false, "closeOnContentClick":false, "openOnClick":false, "maxHeight":600}'
                  <div
                    :key="data.item.id"
                    :selected="data.selected"
                    :disabled="data.disabled"
                    @input="data.parent.selectItem(data.item)"
                  >
                  <v-checkbox value="data.item.selected"></v-checkbox>
                    {{ data.item.title }}
                  </div>
                </template> -->

              <v-autocomplete
                @change="assignArtworksToText(text.id, text.artworks)"
                v-model="text.artworks"
                :disabled="isUpdating"
                :items="artworks"
                box
                chips
                color="grey lighten-1"
                label="Artworks for this text"
                item-value="id"
                multiple
                :item-text="
                  item =>
                    item.title + ', ' + item.accession_number + ', ' + item.name
                "
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    class="chip--select-multi white--text chip--select-multi"
                    @input="remove(data.item.id)"
                    :color="data.item.representative_text_id === text.id ? 'green' : 'black'"
                  >
                    <!-- <v-avatar> <img :src="data.item.avatar"> </v-avatar>  -->
                    <strong v-html="data.item.title"></strong>&nbsp;
                    <span>{{ data.item.accession_number }} </span>&nbsp;
                    <strong v-html="data.item.name"></strong>
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <strong v-html="data.item.title"></strong>&nbsp;
                      <span>{{ data.item.accession_number }} </span>&nbsp;
                      <strong v-html="data.item.name"></strong>
                    </v-list-tile-title>
                    <v-list-tile-sub-title></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
            
            <v-flex xs12 mt-0 mb-4 >
              <!--div class="xs12 flex mx-1">
                <v-flex 
                  style="background-color: #392939; line-height: 23px; height:30px;  " 
                  class="white--text text-uppercase body-2 elevation-0 pl-3 mx-1 pt-1"
                >
                  <span>Representative for Artworks</span>
                </v-flex>
              </!--div-->

              <v-card v-if="text.artworks && text.artworks.length > 0" class="mx-2 elevation-0">
                <v-card-title class="text-uppercase body-2 color-black bg-surface-light">
                  Public website text for artworks
                </v-card-title>
                <v-list two-line dense>
                  <v-list-tile v-for="artwork in text_artworks" :key="artwork.id">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ artwork.title }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ artwork.accession_number }} – <span class="text--secondary">{{ artwork.full_name }}</span></v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-switch
                        :input-value="artwork.representative_text_id === text.id"
                        @change="toggleRepresentative(artwork, text)"
                        hide-details
                        color="green"
                      ></v-switch>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-card>
              <v-card-text v-else class="text-center">
                No artworks associated with this text yet.
              </v-card-text>
            </v-flex>

            <v-flex xs12 px-2>
              <v-autocomplete
                v-model="text.artists"
                :disabled="isUpdatingArtists"
                :items="artists_sorted"
                box
                chips
                color="grey lighten-1"
                label="Selected Artists"
                item-value="id"
                multiple
                :item-text="item => item.name"
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    class="chip--select-multi white--text chip--select-multi"
                    @input="removeArtist(data.item.id)"
                    color="black"
                  >
                    <!-- <v-avatar> <img :src="data.item.avatar"> </v-avatar>  -->
                    <strong v-html="data.item.name"></strong>&nbsp;
                    <!-- <span>{{ data.item.accession_number }} </span>&nbsp;
                    <strong v-html="data.item.name"></strong> -->
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <!-- <v-list-tile-avatar>
                    <img :src="data.item.avatar">
                  </v-list-tile-avatar> -->
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <strong v-html="data.item.name"></strong>&nbsp;
                      <!-- <span>{{ data.item.accession_number }} </span>&nbsp;
                      <strong v-html="data.item.name"></strong> -->
                    </v-list-tile-title>
                    <v-list-tile-sub-title></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>

            <SectionHeader text="Notes" class="mb-2"></SectionHeader>
            <v-flex xs12 sm12 md12 px-0 mx-2>
              <v-textarea
                outline
                v-model="text.notes"
                label="Notes"
                auto-grow
                clearable
                rows="1"
              ></v-textarea>
            </v-flex>

            <div class="language-editors">
              <section class="language-editors__panel">
                <SectionHeader text="Text ENG" class="mr-0 mt-5 mb-2"></SectionHeader>
                <div class="language-editors__hint">English version used as the primary text.</div>
                <text-editor @input="text.content=$event" :value="text.content" :text="text"></text-editor>
              </section>

              <section class="language-editors__panel">
                <SectionHeader text="Text ESP" class="mr-0 mt-5 mb-2"></SectionHeader>
                <div class="language-editors__hint">Optional Spanish translation.</div>
                <text-editor @input="text.content_es=$event" :value="text.content_es" :text="text"></text-editor>
              </section>
            </div>

            <!-- <v-autocomplete box multiple chips color="blue-grey lighten-3" label="Artworks" item-text="title" item-value="id" clearable
                v-model="text.artworks"
                :items="artworks"
              >
                <template v-slot:selection="data">
                  <v-chip close class="chip--select-multi white--text" color="black"
                    :selected="data.selected" @input="remove(data.item)" 
                  >
                    {{ data.item.title }}
                  </v-chip>
                </template>

                <template v-slot:item="data">
                  <template>
                    <v-list-tile-content class="my-4">
                      <v-list-tile-title v-html="data.item.title"></v-list-tile-title>
                      <v-list-tile-sub-title>{{data.item.accession_number}} <b>{{ (data.item.artist ? data.item.artist.name : data.item.name) }}</b></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete> -->

          </v-layout>

          <div v-if="c_user && c_user.roles && c_user.roles.find(r => r.shortcut == 'file_u')" class="text-upload-section mt-5">
            <SectionHeader text="Uploads" class="mr-4"></SectionHeader>
              <!-- <h3 class="mt-5 pl-3">Uploaded text files</h3> -->
              <!-- :artwork="artwork" -->
                <!-- style="width:100%;" -->
            <upload
              class="xs12 mr-4 mt-2"
              :field="{id: 'artwork_text', name: 'artwork_text', category: 'artwork_text', title:'Text uploads'}"
              uploadCategory="artwork_text"
              :text-id="text.id"
            ></upload>
          </div>

        </v-container>
      <!-- </v-card> -->
    </v-form>

  </div>
</template>

<script>
import TextEditor from '@/components/artworks/TextEditor'
import axios from '@/utils/apiClient'
import Upload from '../artworks/Upload'
import SectionHeader from '../layout/SectionHeader'
import { serverBus } from '@/main'

function dynamicSort (property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
    return result * sortOrder
  }
}

export default {
  props: ['editedItem'],
  data () {
    return {
      autoUpdate: true,
      isUpdating: false,
      isUpdatingArtists: false,
      timeout: 3500,
      valid: true,
      countries: this.$store.state.countries,
      dialog: false,
      text: {
        loan: '',
        content: '',
        content_es: '',
        title: 'loading...',
        given_filename: '',
        institution: '',
        show_type: '',
        city: '',
        country: '',
        duration_start_year: null,
        duration_start_month: null,
        duration_start_day: null,
        duration_end_year: null,
        duration_end_month: null,
        duration_end_day: null,
        admin_note: ''
      },
      artists: this.$store.state.artists
    }
  },
  watch: {
    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    },
    isUpdatingArtists (val) {
      if (val) {
        setTimeout(() => (this.isUpdatingArtists = false), 3000)
      }
    }
  },
  methods: {
    toggleRepresentative(artwork, text) {
      const isCurrentlySet = artwork.representative_text_id === text.id
      const newValue = isCurrentlySet ? null : text.id
      this.$emit('showSnackbar', 'Updating public website text.', 'black')
      axios
        .patch(`${this.$globals.apiserver}/artworks/${artwork.id}/set_representative_text`, {
          text_id: newValue
        })
        .then(res => {
          // this.artwork.representative_text_id = this.text.id
          // this.$emit('getArtwork')
          // this.$store.dispatch('loadArtworks')
          this.$store.commit('UPDATE_ARTWORK_REPRESENTATIVE_TEXT', {
            artwork_id: artwork.id,
            representative_text_id: newValue
          })
          // this.$store.dispatch('loadTexts')
          this.$emit('showSnackbar', 'Public website text updated.', 'green')
        })
        .catch(error => {
          this.$emit('showSnackbar', 'Error setting public website text.', 'red')
          console.error(error)
        })
    },
    // toggleRepresentative(artwork) {
    //   // Update the join table artwork_text_artworks since is_representative is stored there
    //   axios.patch(`${this.$globals.apiserver}/artwork_text_artworks.json`, {
    //     artwork_text_artwork: {
    //       artwork_id: artwork.id,
    //       artwork_text_id: this.text.id,
    //       is_representative: artwork.is_representative
    //     }
    //   })
    //   .then(response => {
    //     this.$store.dispatch('showSnackbar', {
    //       text: artwork.is_representative ? 'Set as representative text' : 'Removed as representative text',
    //       color: 'success'
    //     })
    //   })
    //   .catch(error => {
    //     console.error(error)
    //     artwork.is_representative = !artwork.is_representative // revert on error
    //     this.$store.dispatch('showSnackbar', {
    //       text: 'Failed to update representative text status',
    //       color: 'error'
    //     })
    //   })
    // },
    // remove (item) {
    //   this.text.artworks.splice(this.text.artworks.indexOf(item), 1)
    //   this.text.artworks = [...this.text.artworks]
    // },
    remove (item) {
      // this.text.artworks.splice(this.text.artworks.indexOf(item), 1)
      // this.text.artworks = [...this.text.artworks]
      // console.log(item)
      // console.log(this.text.artworks)
      const index = this.text.artworks.indexOf(item)
      // console.log(index)
      if (index >= 0) this.text.artworks.splice(index, 1)
    },
    removeArtist (item) {
      // this.text.artworks.splice(this.text.artworks.indexOf(item), 1)
      // this.text.artworks = [...this.text.artworks]
      // console.log(item)
      // console.log(this.text.artworks)
      const index = this.text.artists.indexOf(item)
      // console.log(index)
      if (index >= 0) this.text.artists.splice(index, 1)
    },
    assignArtworksToText (textId, artworks) {
      const url = `${this.$globals.apiserver}/artwork_texts/${textId}.json`
      axios
        .put(url, { artwork_text: { artwork_ids: artworks } })
        .then(response => {
          this.$store.dispatch('loadTexts')
          // this.result = response.data
          serverBus.$emit('showSnackbar', 'Artworks assigned to text.', 'green')
        })
        .catch(error => {
          console.error(error)
          serverBus.$emit('showSnackbar', 'Failed to assign artworks to text.', 'red')
        })
    },
    saveText () {
      if (this.text.duration_end_year && this.text.duration_end_month && this.text.duration_end_day) {
        this.text.duration_end = this.format_date(
          new Date(
            this.text.duration_end_year,
            this.text.duration_end_month - 1,
            this.text.duration_end_day
          ),
          'YYYY-MM-DD'
        )
      }
      if (this.text.duration_start_year && this.text.duration_start_month && this.text.duration_start_day) {
        this.text.duration_start = this.format_date(
          new Date(
            this.text.duration_start_year,
            this.text.duration_start_month - 1,
            this.text.duration_start_day
          ),
          'YYYY-MM-DD'
        )
      }
      // this.text.artworks = this.artwork_ids
      // console.log(this.text.artworks)

      this.text.artwork_ids = this.text.artworks
      this.text.artist_ids = this.text.artists
      // .map(a => a.id)
      // console.log(this.text)
      // this.text.artworks = this.text.artwork_ids
      let url = `${this.$globals.apiserver}/artwork_texts/${this.text.id}.json`
      axios
        .put(url, { artwork_text: this.text })
        .then(response => {
          this.$store.dispatch('loadTexts')
          this.result = response.data
          serverBus.$emit('showSnackbar', 'Text was saved.', 'green')
        })
        .catch(error => {
          serverBus.$emit('showSnackbar', 'Text was NOT saved. Error occured.', 'red')
          // console.log(error)
        })
    },
    deleteText () {
      let url = `${this.$globals.apiserver}/artwork_texts/${this.text.id}.json`
      axios
        .delete(url, this.text)
        .then(response => {
          this.result = response.data
          serverBus.$emit('showSnackbar', 'Text was deleted.', 'green')
          this.$router.push({name: 'Texts'})
        })
        .catch(error => {
          serverBus.$emit('showSnackbar', 'Text was NOT deleted. Error occured.', 'red')
          // console.log(error)
        })
    },
    getText () {
      let url = `${this.$globals.apiserver}/artwork_texts/${this.$route.params.id}.json`
      axios
        .get(url)
        .then(response => {
          this.text = response.data
          // MUSIM ZMENIT VALUE PRE RADIO GROUP NA STRING LEBO INAK TO NEFUNGUJE
          if (this.text.show_type) {
            this.text.show_type = this.text.show_type.toString()
          }
          this.text.artworks = this.text.artworks.map(a => a.id)
        })
        .catch(error => {
          // console.log(error)
        })
    }
  },
  computed: {
    // retrieve full artworks from ids in a new array
    text_artworks() { 
      if (!this.text.artworks) return []
      if (!this.artworks) return []
      // create new array of artworks from ids
      const artworks = []
      this.text.artworks.forEach(id => {
        const artwork = this.artworks.find(a => a.id === id)
        if (artwork) artworks.push(artwork)
      })
      return artworks
    },
    artworks()  { return this.$store.state.artworks },
    artists_sorted () {
      return Object.assign([], this.artists).sort(dynamicSort('name'))
    },
    artwork_ids () {
      let mm = []
      this.text.artworks.forEach(a => mm.push({ id: a.id }))
      return mm
    }
  },
  beforeMount () {
    if (this.editedItem) {
      this.text = Object.assign({}, this.editedItem)
    }
    this.getText()
  },
  // beforeMount() {
  //   // this.text = Object.assign({},this.$route.params.text)
  //   this.getText();
  // },
  components: { TextEditor, Upload, SectionHeader }

}
</script>

<style scoped>
.text-edit-page {
  min-height: 100%;
  margin: 0 auto;
}
.text-edit-toolbar {
  border-radius: 10px 10px 0 0;
}
.text-edit-content {
  padding-bottom: 48px;
}
.language-editors {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  width: 100%;
  margin-top: 12px;
}
.language-editors__panel {
  min-width: 0;
  padding: 0 14px 18px;
  border: 1px solid #e1dce5;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(57, 41, 57, 0.06);
}
.language-editors__hint {
  margin: 0 2px 12px;
  color: #766d79;
  font-size: 13px;
}
.text-upload-section {
  padding: 18px;
  border: 1px solid #e1dce5;
  border-radius: 10px;
  background: #faf8fb;
}
@media (max-width: 900px) {
  .language-editors {
    grid-template-columns: 1fr;
  }
}
/* .v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
} */
</style>



// WEBPACK FOOTER //
// src/components/texts/EditText.vue